import {
    Badge,
    Box,
    Button,
    CopyButton,
    JsonInput,
    Text,
    Tooltip,
    rem,
} from '@mantine/core';
import { IconCopy, IconCopyCheck } from '@tabler/icons-react';

const MessageGroupCell = ({ cell, accessorKey }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Tooltip label={`ID ${rowData.messageGroupId}`}>
            <Text>{rowData.messageGroup || '---'}</Text>
        </Tooltip>
    );
};

const MessageGroupColumn = ({ header, accessorKey, columnProps = {} }) => ({
    accessorKey: accessorKey,
    header: header,
    size: 2,
    minSize: 40,
    ...columnProps,
    Cell: ({ cell }) => (
        <MessageGroupCell
            cell={cell}
            accessorKey={accessorKey}
        />
    ),
    Footer: (info) => {
        return <></>;
    },
});
export default MessageGroupColumn;
